// removed by extract-text-webpack-plugin
module.exports = {"slider_container":"mR4UFy-8swBo8sJZ6hfvb","slider_label":"_34sdmSYuXC2P8pub2tZTjF","left_label":"_3be3sZ3Hlgs1s-TqUcZ4NI","right_label":"_35WNO_EyyeF_sjTGwXZ9Lr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MozartSlider/MozartSlider.scss
// module id = 2345
// module chunks = 0